import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
@Directive({selector: '[StyleRow]'})
export class StyleRowDirective implements OnInit {
  @Input() StyleRow: any;
  @Input() rowCondition: Array<string | boolean> | string | boolean = false;
  @Input() rowFontColor: Array<string> | string;
  @Input() rowBgColor: Array<string> | string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (
      Array.isArray(this.rowCondition) &&
      Array.isArray(this.rowFontColor) &&
      Array.isArray(this.rowBgColor)
    ) {
      this.rowCondition.forEach((cond, idx) => {
        this.setRowStyle(cond, this.rowFontColor[idx], this.rowBgColor[idx]);
      });
    } else if (
      !Array.isArray(this.rowCondition) &&
      !Array.isArray(this.rowFontColor) &&
      !Array.isArray(this.rowBgColor)
    ) {
      this.setRowStyle(this.rowCondition, this.rowFontColor, this.rowBgColor);
    }
  }

  setRowStyle(rowCondition: string | boolean, rowFontColor: string, rowBgColor: string) {
    if (rowCondition == 'Y' || rowCondition == 'true' || rowCondition == true) {
      if (rowBgColor) {
        this.renderer.setStyle(this.el.nativeElement, 'background-color', rowBgColor);
      }
      if (rowFontColor) {
        this.renderer.setStyle(this.el.nativeElement, 'color', rowFontColor);
      }
    }
  }
}
